
import React from "react";
import { TrendingUp } from "lucide-react";
import { UseFormReturn } from "react-hook-form";
import { z } from "zod";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { advancedTierSchema } from "@/contexts/program-creation/types";

interface PerformanceSectionProps {
  form: UseFormReturn<z.infer<typeof advancedTierSchema>>;
}

export default function PerformanceSection({ form }: PerformanceSectionProps) {
  return (
    <div className="space-y-5">
      <div className="flex items-center gap-2 text-white/90 border-b border-white/20 pb-2">
        <TrendingUp size={18} />
        <h4 className="font-medium">Performance</h4>
      </div>
      
      <FormField
        control={form.control}
        name="recentPerformance"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white/90 text-sm">
              When was their last peak performance or PR, and what was it?
            </FormLabel>
            <FormControl>
              <Textarea 
                placeholder="Deadlifted 405lbs for 3 reps last month. Benched 315lbs at their last competition. Added 10kg to their squat 1RM." 
                className="bg-white/20 border-white/30 text-white min-h-[80px]"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="weaknesses"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white/90 text-sm">
              What do you consider their weaknesses or areas for improvement in training?
            </FormLabel>
            <FormControl>
              <Textarea 
                placeholder="Grip strength is limiting their deadlift. Poor bracing technique on heavy squats. Weak lockout on bench press." 
                className="bg-white/20 border-white/30 text-white min-h-[80px]"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
